import {
  getTheme,
  Stack,
  Icon,
  Dropdown,
  IDropdownOption
} from "@fluentui/react";
import { useCallback } from "react";

import { AccountSignatureContact } from "./interfaces";

import { AccountContactType } from "@/components/Contracts/ConfirmationStep/Signature/signature.interface";
import { phoneNumberFormatter } from "@/utils/PhoneNumberFormatter";

interface RenderDynamicContactOptionsProps {
  contacts: AccountSignatureContact[];
  setSelectedContact: (
    value: React.SetStateAction<AccountSignatureContact>
  ) => void;
  selectedContact?: AccountSignatureContact;
  contactType?: AccountContactType;
}

export function RenderDynamicContactOptions({
  contactType,
  contacts,
  selectedContact,
  setSelectedContact
}: RenderDynamicContactOptionsProps) {
  const theme = getTheme();
  const isWhatsApp = contactType === AccountContactType.WHATSAPP;
  const getContactIcon = (isWhatsApp: boolean) => {
    return isWhatsApp ? "CellPhone" : "Mail";
  };

  const contactOptions: IDropdownOption[] = contacts.map(contact => ({
    key: contact.id,
    text: isWhatsApp ? phoneNumberFormatter(contact.contact) : contact.contact
  }));

  const handleContactSelectionChange = useCallback(
    (_: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
      if (option) {
        const contact = contacts.find(contact => contact?.id === option?.key);
        setSelectedContact(contact);
      }
    },
    [contacts, setSelectedContact]
  );

  return (
    <Stack
      styles={{
        root: {
          padding: "16px",
          backgroundColor: theme.palette.white,
          borderRadius: "4px",
          border: `1px solid ${theme.palette.neutralQuaternaryAlt}`,
          boxShadow: theme.effects.elevation4,
          width: "100%"
        }
      }}
      tokens={{ childrenGap: 12 }}
    >
      <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
        <Icon
          iconName={getContactIcon(isWhatsApp)}
          styles={{
            root: {
              fontSize: "20px",
              color: theme.palette.themePrimary
            }
          }}
        />

        <span
          style={{
            fontSize: "15px",
            color: theme.palette.neutralPrimary
          }}
        >
          Selecione o Contato:
        </span>
      </Stack>

      <Dropdown
        placeholder="Escolha um contato"
        options={contactOptions}
        selectedKey={selectedContact?.id}
        onChange={handleContactSelectionChange}
        styles={{
          dropdown: { width: "100%" },
          root: {
            width: "100%"
          }
        }}
      />
    </Stack>
  );
}
